module.exports = __webpack_public_path__ + "img/17.0be4caa5.jpg";